import { formatDistanceToNow } from "date-fns";

interface RelativeTimeProps {
  date: string | Date;
}

/**
 * Renders a relative time like "3 minutes ago" with the absolute ISO
 * timestamp on hover (`title` attribute) and as the `datetime` attribute
 * for accessibility / machine-reading.
 *
 * Note: not auto-refreshing. Tables that show RelativeTime will rerender
 * naturally on TanStack Query refetches — that's enough granularity.
 */
export function RelativeTime({ date }: RelativeTimeProps) {
  const d = typeof date === "string" ? new Date(date) : date;
  const iso = d.toISOString();
  const text = formatDistanceToNow(d, { addSuffix: true });
  return (
    <time dateTime={iso} title={iso} className="text-text-muted">
      {text}
    </time>
  );
}
